import React, { Component } from 'react';
import styles from './OrganisationProfileCard.module.css';

class OrganisationProfileCard extends Component {
    render() {
        const { organisationData } = this.props;
        let physicalAddress = organisationData.organisationInfo?.contactDetails?.physicalAddress?.line1 + ', ' + organisationData.organisationInfo?.contactDetails.physicalAddress?.line2;
        return (
            <div className={styles.profileContainer} >
                <div className={styles.profileHeader}>
                    <div className={styles.profilePicture}>
                        <img src={organisationData.avatar} alt="Profile" />
                    </div>
                    <p>{organisationData.organisationInfo?.name}</p>
                </div>

                <div className={styles.profileDetails}>
                    <div className={styles.detailsSection}>
                        <h3>Organisation Information</h3>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Registered name:</span>
                            <span className={styles.detailValue}>{organisationData.organisationInfo?.name}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Organisation Type:</span>
                            <span className={styles.detailValue}>{organisationData.organisationType}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Physical address:</span>
                            <span className={styles.detailValue}>{physicalAddress}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Province:</span>
                            <span className={styles.detailValue}>{organisationData.organisationInfo?.contactDetails?.physicalAddress?.suburb}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Postal code:</span>
                            <span className={styles.detailValue}>{organisationData.organisationInfo?.contactDetails?.physicalAddress?.code}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
export default OrganisationProfileCard;
